import { render, staticRenderFns } from "./UserRoleEditForm.vue?vue&type=template&id=114ece2d&scoped=true&"
import script from "./UserRoleEditForm.vue?vue&type=script&lang=js&"
export * from "./UserRoleEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleEditForm.vue?vue&type=style&index=0&id=114ece2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ece2d",
  null
  
)

export default component.exports